import React from 'react';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Box, Text } from '../base';

/**
 * UI component letting the user know about an error that occurred within the
 * component tree that uses Ellington
 */
const ErrorBoundaryMessage = ({ isCentralStation }) => {
  return (
    <Box
      p="16px"
      bg="background"
      id="error-boundary-message"
      flow={25}
      height="100%"
      justify="center"
    >
      <Box justify="center" horizontal>
        <AttentionTriangleIcon height={16} width={16} color="secondaryLink" />
        <Text
          size="large"
          color="primaryText"
          fontWeight="bold"
          textAlign="center"
          inline
          pl="16px"
        >
          An error has occurred.
        </Text>
      </Box>
      <Text size="normal" color="secondaryText" textAlign="center">
        We are unable to show data at this time.{' '}
        {!isCentralStation ? (
          <>Please submit a ticket via the "Support" tab.</>
        ) : (
          <>
            <a href="mailto:support@rapidsos.com">
              <Text size="normal" color="primaryBase" inline underline>
                contact support
              </Text>
            </a>
            .
          </>
        )}
      </Text>
    </Box>
  );
};

export default ErrorBoundaryMessage;
